import React from "react";
import IcoMoon from "react-icomoon";
import iconSet from "./selection.json";
const CustomIcon = (props) => <IcoMoon iconSet={iconSet} {...props} />;

export default CustomIcon;
